import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "font-weight-bold mr-1"
};
import { ref } from 'vue';
import LlTooltip from '@/components/LlTooltip.vue';
export default {
  __name: 'LlTextField',
  props: {
    prefix: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    type: {
      type: [String, Number],
      default: 'text'
    },
    modelValue: {
      type: [String, Number, Date],
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'outlined'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: [Boolean, String],
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: 'text-sm'
    },
    info: {
      type: String,
      default: ''
    },
    incomingClass: {
      default: '',
      required: false
    },
    incomingName: {
      type: String,
      default: '',
      required: false
    },
    step: {
      type: [Number, String],
      default: 1
    },
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    },
    rules: {
      type: Array,
      default: () => []
    },
    dataCy: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change', 'blur', 'click'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const inputRef = ref(null);
    const props = __props;
    const emit = __emit;
    const handleUpdateValue = value => {
      emit('update:modelValue', value);
      emit('change', value);
    };
    const handleBlur = event => {
      emit('blur', event);
    };
    const focus = () => {
      inputRef.value?.focus();
    };
    const blur = () => {
      inputRef.value?.blur();
    };
    __expose({
      focus,
      blur,
      inputRef
    });
    return (_ctx, _cache) => {
      const _component_v_text_field = _resolveComponent("v-text-field");
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.label.length || __props.info.length ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(__props.labelClass)
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _withDirectives(_createElementVNode("span", _hoisted_1, "*", 512), [[_vShow, __props.isRequired]]), _withDirectives(_createVNode(LlTooltip, {
        text: __props.info,
        icon: "help"
      }, null, 8, ["text"]), [[_vShow, __props.info.length]])], 2)) : _createCommentVNode("", true), _createVNode(_component_v_text_field, _mergeProps({
        ref_key: "inputRef",
        ref: inputRef,
        "data-cy": __props.dataCy,
        prefix: __props.prefix,
        density: "compact",
        type: __props.type,
        modelValue: __props.modelValue,
        "onUpdate:modelValue": handleUpdateValue,
        id: __props.id,
        placeholder: __props.placeholder,
        variant: __props.variant,
        disabled: __props.disabled,
        readonly: __props.readonly,
        "bg-color": __props.readonly ? 'readonly-surface' : undefined,
        "hide-details": __props.hideDetails,
        class: __props.incomingClass,
        name: __props.incomingName,
        step: __props.step,
        min: __props.min,
        max: __props.max,
        rules: __props.rules,
        required: __props.required,
        onBlur: handleBlur,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event))
      }, _ctx.$attrs), null, 16, ["data-cy", "prefix", "type", "modelValue", "id", "placeholder", "variant", "disabled", "readonly", "bg-color", "hide-details", "class", "name", "step", "min", "max", "rules", "required"])], 64);
    };
  }
};